import * as React from 'react';
import { Avatar as UIKitAvatar } from '@cian/ui-kit';

import { EType } from '../../types/users';

export interface IAvatarProps {
  avatarUrl: string;
  type: EType;
}

export const Avatar: React.VFC<IAvatarProps> = ({ avatarUrl, type }) => {
  return (
    <UIKitAvatar data-testid="Avatar" size={48} src={avatarUrl} type={type === EType.Regular ? 'user' : 'builder'} />
  );
};
